<template>
  <v-app>
    <v-main>
      <Login v-if="!isLoggedIn"/>
      <ContentView v-else/>
      <BasicSnackbar/>
    </v-main>
  </v-app>
</template>

<script>
import Login from './views/LoginView.vue'
import BasicSnackbar from "@/components/BasicSnackbar.vue";
import ContentView from "@/views/ContentView.vue";

export default {
  components: {
    BasicSnackbar,
    Login,
    ContentView
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
